import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MssFieldBaseFieldTypeComponent } from '../mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';

@Component({
  templateUrl: 'radio-button.component.html',
  styleUrls: ['radio-button.component.scss'],
  imports: [
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    ...MSS_FORMLY_IMPORTS,
  ],
})
export class RadioButtonFieldTypeComponent extends MssFieldBaseFieldTypeComponent {

  public get optionsArray(): any[] {
    return (this.props.options as any[]) ?? [];
  }
}
